const shortMonthNames = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

const smallMonthNames = [
  'jan', 'feb', 'mar', 'apr', 'may', 'jun',
  'jul', 'aug', 'sep', 'oct', 'nov', 'dec'
];

const fullDays = [
  "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
];

const days = [
  "sun", "mon", "tue", "wed", "thu", "fri", "sat"
];

module.exports = {
  
  date: (date, prefomattedDate = false, hideYear = false) => {
    const day = date.getDate();
    const monthNum = date.getMonth();
    const month = shortMonthNames[monthNum];
    const year = date.getFullYear();
    const hours = date.getHours();
    let minutes = date.getMinutes();
  
    if (minutes < 10) {
      minutes = `0${ minutes }`;
    }
  
    if (prefomattedDate) {
      return `${ prefomattedDate } at ${ hours }:${ minutes }`;
    }
  
    if (hideYear) {
      return `${ month } ${ day }`;
    }
  
    return `${ monthNum + 1 }/${ day }/${ year }`;
  },
  
  
  time: (timestamp) => {
    let date = new Date(timestamp);
    
    let period = "am";
    let hour = date.getHours();
    if (hour >= 12) period = "pm";
    if (hour > 12) {
      hour-=12;
    }
    if (hour == 0) {
      hour = 12;
    }
    let minute = date.getMinutes();
    if (minute < 10) {
      minute = `0${ minute }`;
    }
    
    return `${hour}:${minute}${period}`;
  },
  
  
  sixDigitDate: (date) => {
    
    let sp = date.split("-");
    let year = sp[0].slice(2);
    let month = sp[1];
    let day = sp[2];
    
    return `${ month }/${ day }/${ year }`;
    
  },
  
  
  mysqlDateNow: () => {
    let tdate = new Date();
    let year = tdate.getFullYear();
    let month = tdate.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    let date = tdate.getDate();
    date = date < 10 ? "0" + date : date;
    
    return year + "-" + month + "-" + date;
  },
  
  
  mysqlTimeNow: () => {
    let tdate = new Date();
    let hour = tdate.getHours();
    if (hour < 9) hour = "0" + hour.toString();
    let minute = tdate.getMinutes();
    return hour + ":" + minute + ":00";
  },
  
  
  // get the time now, but only return in five minute increments, rounded
  // so, if it's 5:16, it will round it down to 5:15.
  // if it's 5:19, it will round up to 5:20
  mysqlTimeNow5Inc: () => {
    let tdate = new Date();
    let hour = tdate.getHours();
    if (hour < 9) hour = "0" + hour.toString();
    let minute = Math.round(tdate.getMinutes() / 5) * 5;
    return hour + ":" + minute + ":00";
  },
  
  
  // like the above function, but always rounds up using ceil
  mysqlTimeNow5IncCeil: () => {
    let tdate = new Date();
    let hour = tdate.getHours();
    if (hour < 9) hour = "0" + hour.toString();
    let minute = Math.ceil(tdate.getMinutes() / 5) * 5;
    if (minute == 60) {
      hour++;
      minute = 0;
    }
    if (minute < 10) minute = `0${minute}`;
    return hour + ":" + minute + ":00";
  },
  
  
  // get tomorrow
  tomorrow: () => {
    let tdate = new Date();
    
    let oDate = new Date(tdate.getFullYear(), tdate.getMonth(), tdate.getDate() + 1);
    let year = oDate.getFullYear();
    let month = oDate.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    let date = oDate.getDate();
    date = date < 10 ? "0" + date : date;
    
    return `${ year }-${ month }-${ date }`;
    
  },
  
  
  dateToTimestamp: (date) => {
    if (date.length != 10) throw "birthday has incorrect length";
    
    let split = date.split("-");
    if (split.length != 3) throw "birthday has incorrect format";
    
    let out = new Date(split[0], split[1], split[2]).getTime();
    if (isNaN(out) == true) throw "birthday is not a number";
    
    return out;
  },
  
  
  getAge: (date) => {
    let user = module.exports.dateToTimestamp(date);
    let today = Date.now();
    
    // calculate how old each user is
    // we don't need a perfect calculation here...
    const YEAR_IN_MS = 31536000000; // 365 * 24 * 60 * 60 * 1000
    return Math.floor( (today - user) / YEAR_IN_MS );
    
  },
  
  
  // takes a mysql style date/time and splits it into it's components
  splitDate: (dateStr) => {
    
    // get date dt[0] and time dt[1]
    let dt = dateStr.split(" ");
    
    let date = dt[0].split("-");
    let time = dt[1].split(":");
    
    return {year: date[0], month: parseInt(date[1]) - 1, date: date[2], hour: time[0], minutes: time[1], seconds: time[2]};
    
  },
  
  
  // needs splitDate run on it already - "date" is the return of splitDate
  day: (date) => {
    let oDate = new Date(date.year, date.month, date.date);
    return days[ oDate.getDay() ];
  },
  
  
  // needs splitDate run on it already - "date" is the return of splitDate
  month: (date) => {
    let oDate = new Date(date.year, date.month, date.date);
    return smallMonthNames[ oDate.getMonth() ];
  },
  
  
}


// module.exports.startEndTimestamps();
// module.exports.startEndTimestamps({year: 2024, month: 1, date: 29, hour: 11, minutes: 31, seconds: 0});